// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabA_TheComp__XuaEB","TheComp2":"TabA_TheComp2__u5mux"};